<template>
    <div>
        <el-select
            v-if="loggedUser.role === UserRoles.ADMIN && !CallForm.isFullProposal"
            class="filter-select mr-2 mb-2"
            style="position: absolute; right: 14.5rem; margin-top: 74px; z-index: 10;"
            v-model="CallForm.status"
            :placeholder="$t('proposals.select__change_proposal_status')"
            @change="changeProposalStatus"
            >
            <el-option v-for="item in proposalStatuses" :key="item" :label="item" :value="item"/>
        </el-select>
        <el-select
            v-if="loggedUser.role === UserRoles.ADMIN && CallForm.isFullProposal"
            class="filter-select mr-2 mb-2"
            style="position: absolute; right: 14.5rem; margin-top: 74px; z-index: 10;"
            v-model="CallForm.fp_status"
            :placeholder="$t('proposals.select__change_proposal_status')"
            @change="changeFullProposalStatus"
            >
            <el-option v-for="item in proposalStatuses" :key="item" :label="item" :value="item"/>
        </el-select>
        <base-alert type="warning" dismissible>
            {{ $t('notify.proposal_deadline') }}
        </base-alert>
        <component-loader
            :key="$i18n.locale"
            :component-name="componentName"
            :default-component-name="defaultComponentName"
            id="applicationComponent"
            v-if="componentInitialized">
        </component-loader>
    </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import { ProposalService, CallService, DocumentService, UserRoles, CallForm, FileUploadService } from "@/services";
import { Select, Option } from 'element-ui';
import ComponentLoader from './ComponentLoader';
import swal from 'sweetalert2';
import {BaseAlert} from 'src/components';

export default
{
    components:
    {
        [Select.name]: Select,
        [Option.name]: Option,
        ComponentLoader,
        BaseAlert,
    },
    data()
    {
        return {
            UserRoles,
            CallForm,
            callId: parseInt(this.$route.params.callId),
            proposalId: parseInt(this.$route.params.proposalId),
            componentInitialized: false,
            componentName: 'Dynamic',
            defaultComponentName: 'Default',
            proposalStatuses:
            [
                'DRAFT',
                'SUBMITTED'
            ],
            fullProposalStatus: "",
            data: {},
        };
    },
    async beforeCreate()
    {
        let vm = this;
        let loader = this.$loading.show();

        const callId = parseInt(vm.$route.params.callId);
        const proposalId = parseInt(vm.$route.params.proposalId);
        const objectAssignDeep = require('object-assign-deep');

        vm.callId = callId;
        vm.proposalId = proposalId;

        vm.loggedUser = vm.$store.getters['Auth/loggedUser'];

        CallForm.init();

        await CallService.get(callId).then((response) =>
        {
            let componentName = response.data.componentName;
            let schema = JSON.parse(response.data.schema);
            // let schema = response.data.schema;

            CallForm.model = _.cloneDeep(schema);
            CallForm.files = _.cloneDeep(schema);

            vm.componentName = componentName;
            vm.componentInitialized = true;
        });

        CallForm.isEditable = true;

        if (!proposalId)
        {
            CallForm.initialized = true;
            CallForm.isEditable = true;
            CallForm.isFPEditable = true;

            loader.hide();

            return;
        }

        await ProposalService.getProposal(proposalId).then((response) =>
        {
            CallForm.model = objectAssignDeep(CallForm.model, response.data.data);
            CallForm.files = { ...CallForm.files,
                ...response.data.files
            };

            CallForm.reference = response.data.reference;
            CallForm.objectives = { ...CallForm.objectives,
                ...response.data.objectives
            };
            CallForm.organization_type = { ...CallForm.organization_type,
                ...response.data.organization_type
            };
            CallForm.user = { ...CallForm.user,
                ...response.data.user
            };
            CallForm.status = response.data.status;
            CallForm.fp_status = response.data.fp_status;

            this.fullProposalStatus = response.data.fp_status


            CallForm.technical_status = response.data.technical_status;

            if (!CallForm.model.full_proposal.objectives)
            {
                CallForm.model.full_proposal.objectives = {
                    sdgs: {_forceObject: true},
                    targets: {_forceObject: true}
                };
            }

            if (!CallForm.model.full_proposal.objectives.sdgs)
            {
                CallForm.model.full_proposal.objectives.sdgs = {_forceObject: true};
            }

            if (!CallForm.model.full_proposal.objectives.targets)
            {
                CallForm.model.full_proposal.objectives.targets = {_forceObject: true};
            }

            CallForm.isEditable = vm.loggedUser.role === UserRoles.APPLICANT && response.data.status !== 'SUBMITTED';
            CallForm.isFPEditable = vm.loggedUser.role === UserRoles.APPLICANT && response.data.fp_status !== 'SUBMITTED';
            CallForm.initialized = true;
            CallForm.has_revision = response.data.has_revision;

            CallForm.regionId = response.data.region_id;
        }).catch((error) =>
        {
            console.log(error);
            // vm.$router.push('/');
        });

        loader.hide();
    },
    methods:
    {
        async save(isSubmit)
        {
            const vm = this;
            const loader = vm.$loading.show();
            let data = CallForm.model;
            let isSuccess = false;
            let hasClosed = false;

            if(CallForm.isRevisedTabActive && CallForm.revision_status !== "SUBMITTED"){
                ProposalService.updateRevisionStatus(vm.proposalId,
                    {
                        status: "SUBMITTED"
                    }).then(function (response)
                {
                    CallForm.isFPEditable = false;
                    CallForm.initialized = true;

                });

                this.fullProposalStatus = "SUBMITTED"
                this.CallForm.revision_status = "SUBMITTED"

            }

            await ProposalService.saveProposal({
                callId: vm.callId,
                proposalId: vm.proposalId,
                userId: vm.$store.getters['Auth/loggedUser'].id,
                regionId: CallForm.regionId,
                isFullProposal: CallForm.isFullProposal,
                is_revision: CallForm.is_revision,
                revision_status: "SUBMITTED",
                data: data,
            }).then((response) =>
            {
                vm.proposalId = response.data.proposalId;

                // Redirect URL so we have the proposal id
                vm.$router.push('/proposals/fill/' + vm.callId + '/' + vm.proposalId);

                isSuccess = true;
                hasClosed = response.data.hasClosed;
            }).catch((error) =>
            {
                if (error.data.error === 'permission_error')
                {
                    alert(error.data.error);
                    // vm.$router.push('/');
                }
                else
                {
                    alert(error.data.error);
                    // vm.$router.push('/');
                }
            });

            if (!isSuccess)
            {
                loader.hide();
                return ;
            }

            await vm.uploadFiles();

            loader.hide();

            if (hasClosed)
            {
                vm.showNotification('call-ended');
            }
            else if (isSubmit)
            {
                vm.showNotification('submitted');
            }
            else
            {
                vm.showNotification('save-progress');
            }
            if (status !== undefined && status === 'submitted')
            {
                vm.$router.push('/ongoing-applications');
            }
        },

        async uploadFiles()
        {
            let files = CallForm.files;
            let promises = [];

            for (let section in files)
            {
                if (CallForm.files.hasOwnProperty(section))
                {
                    for (let subSection in files[section])
                    {
                        if (files[section].hasOwnProperty(subSection))
                        {
                            let fileToUpload = files[section][subSection];

                            if (fileToUpload instanceof File)
                            {
                                let formData = new FormData();

                                formData.append('file', fileToUpload);
                                formData.append('section', fileToUpload.section);
                                formData.append('$section', section);
                                formData.append('$subSection', subSection);

                                if (fileToUpload.id)
                                {
                                    formData.append('id', fileToUpload.id);
                                }

                                let promise = FileUploadService.uploadProposalFile({
                                    proposalId: this.proposalId,
                                    formData: formData
                                }).then(function (response)
                                {
                                    const fdSection = formData.get('$section');
                                    const fdSubSection = formData.get('$subSection');

                                    files[fdSection][fdSubSection] =
                                    {
                                        id: response.data.id,
                                        name: response.data.filename,
                                        download: response.data.download
                                    };
                                }).catch(function (error)
                                {
                                    console.log('File Upload Error', error);
                                });

                                promises.push(promise);
                            }
                        }
                    }
                }
            }

            return await Promise.all(promises);
        },

        async submit()
        {
            const vm = this;

            vm.showNotification('complete-progress');

            vm.save(true);

            await ProposalService.submitProposal({
                proposalId: vm.proposalId,
                isFullProposal: CallForm.isFullProposal,
            }).then(() =>
            {
                CallForm.isEditable = false;

                if (CallForm.isFullProposal)
                {
                    CallForm.isFPEditable = false;
                }
            });
        },

        async changeProposalStatus()
        {
            const vm = this;

            if (confirm(vm.$t('proposals.confirm__change_proposal_status')))
            {
                ProposalService.updateProposalStatus(vm.proposalId,
                {
                    status: CallForm.status,
                }).then(function (response)
                {
                    CallForm.isEditable = vm.loggedUser.role === UserRoles.APPLICANT && CallForm.status !== 'SUBMITTED';
                    CallForm.isFPEditable = vm.loggedUser.role === UserRoles.APPLICANT && CallForm.fp_status !== 'SUBMITTED';
                    CallForm.initialized = true;
                });
            }
        },

        async changeFullProposalStatus()
        {
            const vm = this;

            if (confirm(vm.$t('proposals.confirm__change_proposal_status')))
            {
                ProposalService.updateProposalStatus(vm.proposalId,
                {
                    status: CallForm.fp_status,
                    isFullProposal: CallForm.isFullProposal,
                }).then(function (response)
                {
                    CallForm.isEditable = vm.loggedUser.role === UserRoles.APPLICANT && CallForm.status !== 'SUBMITTED';
                    CallForm.isFPEditable = vm.loggedUser.role === UserRoles.APPLICANT && CallForm.fp_status !== 'SUBMITTED';
                    CallForm.initialized = true;
                });
            }
        },

        showNotification(type)
        {
            if (type === 'save-progress')
            {
                swal({
                    title: this.$t('general.notification__success'),
                    html: this.$t('general.notification__progress_saved').split("\n").join("<br>"),
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-primary btn-fill',
                    // type: 'success'
                });
            }
            else if (type === 'complete-progress')
            {
                swal({
                    title: this.$t('general.notification__success'),
                    html: this.$t('general.notification__application_submitted').split("\n").join("<br>"),
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-primary btn-fill',
                    // type: 'success'
                });
            }
            else if (type === 'submitted')
            {
                swal({
                    title: this.$t('general.notification__success'),
                    html: this.$t('general.notification__application_successfully_submitted').split("\n").join("<br>"),
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-primary btn-fill',
                    // type: 'success'
                });
            }
            else if (type === 'call-ended')
            {
                swal({
                    title: this.$t('general.notification__warning'),
                    html: this.$t('general.notification__deadline_passed').split("\n").join("<br>"),
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-primary btn-fill',
                    // type: 'error'
                });
            }
            else if (type === 'revision-validated')
            {
                swal({
                    title: this.$t('general.notification__success'),
                    html: this.$t('general.notification__revision_validated').split("\n").join("<br>"),
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-primary btn-fill',
                    // type: 'success'
                });
            }
        },
    },
    mounted()
    {
        EventBus.$off('grant-save-progress');
        EventBus.$on('grant-save-progress', data =>
        {
            this.save();
        });

        EventBus.$off('grant-complete-progress');
        EventBus.$on('grant-complete-progress', data =>
        {
            this.submit();
        });
    },
};
</script>
